import * as React from 'react';
import { useEditorContext } from 'ui-components/RichTextEditor/tiptap/editor_context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { useLocalization } from '~/framework';
import { TiptapButton } from '../../TiptapButton';

export const AddColumnBeforeButton = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().addColumnBefore().run()}
         icon={<FontAwesomeIcon icon={faArrowLeft} />}
         title={_js('Add column to the left')}
         isDisabled={!editor.can().addColumnBefore()}
      />
   );
};
